// extracted by mini-css-extract-plugin
module.exports = {"title":"ForgotPassword_title__2MGYH","circle":"ForgotPassword_circle__33jKG","form":"ForgotPassword_form__3ocAy","tip":"ForgotPassword_tip__36x4R"};